type SwitchProps = {
    checked: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
    label: string;
};

const Switch = ({ checked, onChange, disabled = false, label }: SwitchProps) => {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={label}
            disabled={disabled}
            onClick={() => onChange?.(!checked)}
            className={`relative shrink-0 w-10 h-6 rounded-full transition-colors duration-200 border ${
                checked ? "bg-[#2dbf25] border-[#25a11f]" : "bg-black/25 border-white/15"
            } ${disabled ? "cursor-default opacity-60" : "cursor-pointer"} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-300`}
        >
            <span
                className={`absolute top-0.5 left-0.5 w-[18px] h-[18px] rounded-full bg-white shadow transition-transform duration-200 ${
                    checked ? "translate-x-4" : "translate-x-0"
                }`}
            ></span>
        </button>
    );
};

export default Switch;
